import { ChangeDetectionStrategy, Component } from '@angular/core'
import { FormControl } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CustomFieldConfigType, CustomFieldControl, SharedModule } from '@vendure/admin-ui/core'

@Component({
    selector: 'kb-reservations-count-link',
    template: `
        {{ formControl.value }}
        <!-- the reservations list shows contact data and needs ReadCustomer -->
        <a *vdrIfPermissions="'ReadCustomer'" [routerLink]="['/extensions/reservations/product', productId]">
            View Pre-Sale Subscriptions
        </a>
    `,
    styles: [``],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SharedModule],
})
export class ReservationCountLinkComponent implements CustomFieldControl {
    readonly: boolean
    config: CustomFieldConfigType
    formControl: FormControl

    get productId(): string | null {
        return this.route.snapshot.paramMap.get('id')
    }

    constructor(private route: ActivatedRoute) {}
}
